import React, {
  useEffect,
  useContext,
  useState,
} from 'react';
import { Layout } from 'antd';
import { useTranslation } from 'react-i18next';

import PageHeaderBar from '../../components/PageHeaderBar';
import MeteringSitesTable from '../../components/MeteringSitesTable';
import { TYPES } from '../../constants/meteringSites';
import Context from '../../context';
import ButtonSelector from '../../components/ButtonSelector';
import { STATES_NAMES } from '../../constants/deliveryRelationships';

const CityGates = () => {
  const { t } = useTranslation();
  const [selectedState, setSelectedState] = useState('all');
  const {
    selectedMarketPartyId,
    updateMeteringSites,
    updateMeteringPointAnalysers,
    updateMeteringPointOwnerships,
  } = useContext(Context);

  useEffect(() => {
    updateMeteringSites();
    updateMeteringPointAnalysers();
    updateMeteringPointOwnerships();
  }, [selectedMarketPartyId]);

  return (
    <>
      <PageHeaderBar
        title={t('deliveryRelationship.title.cityGates')}
        span={{ title: 12, action: 12 }}
        actionItems={(
          <ButtonSelector
            t={t}
            title="statusFilter"
            options={['all', ...STATES_NAMES]}
            defaultValue={selectedState}
            onChange={({ target: { value } }) => setSelectedState(value)}
          />
        )}
      />
      <Layout.Content className="layout__container__page__content">
        <MeteringSitesTable typesToShow={[TYPES.CITYGATE]} selectedState={selectedState} />
      </Layout.Content>
    </>
  );
};

CityGates.displayName = 'City Gates';

export default CityGates;
